// extracted by mini-css-extract-plugin
export default {"EtlNoteToolbar__Button":"EtlNoteToolbar_EtlNoteToolbar__Button__sLHlP","EtlNoteToolbar__Tooltip":"EtlNoteToolbar_EtlNoteToolbar__Tooltip__3NkT0"};